import TemplateContents from "./TemplateContents";
import { gsap } from "gsap";

export default class extends TemplateContents {
  constructor(param) {
    super(param);
  }

  init() {
    super.init();

    this.threeDContainer = document.querySelector(
      "main.top .hero .three_d_container",
    );

    // Three.js用のcanvasがあれば削除し、CSS 3D用のステージを作成
    this.threeDContainer.innerHTML = "";
    this.stage = document.createElement("div");
    this.stage.classList.add("html_stage");
    this.threeDContainer.appendChild(this.stage);

    // 背景用オーバーレイ（stageとfrontStageの間）
    this.overlay = document.createElement("div");
    this.overlay.classList.add("html_overlay");
    this.threeDContainer.appendChild(this.overlay);

    // 手前表示用のステージを作成（z-indexでレイヤーを分ける）
    this.frontStage = document.createElement("div");
    this.frontStage.classList.add("html_stage", "front_stage");
    this.threeDContainer.appendChild(this.frontStage);

    this.sw = window.innerWidth;
    this.sh = window.innerHeight;

    this.setVars();
    this.createElements();
    this.getSectionsHeight();

    this.initConceptVideo();
  }

  initConceptVideo() {
    // 動画の出し分け (800px以上をPCとする)
    const isPC = this.sw >= this.pack.BP;

    const videoFileName = isPC
      ? "concept_visual_pc.mp4"
      : "concept_visual_sp.mp4";

    // assetsパスを使ってパスを構築
    const videoPath = this.pack.ASSETS_PATH + "video/" + videoFileName;

    this.conceptVideo.src = videoPath;
    this.conceptVideo.load();
  }

  setVars() {
    super.setVars();

    this.productImgFiles = [
      // { filename: "01.webp", id: 1 },
      // { filename: "07.webp", id: 2 },
      { filename: "13.webp", id: 1 },
      { filename: "14.webp", id: 2 },
      { filename: "15-1.webp", id: 3 },
      { filename: "15-2.webp", id: 3 },
      { filename: "15-3.webp", id: 3 },
      { filename: "16-1.webp", id: 4 },
      { filename: "16-2.webp", id: 4 },
      { filename: "16-3.webp", id: 4 },
      { filename: "17-1.webp", id: 5 },
      { filename: "17-2.webp", id: 5 },
      { filename: "17-3.webp", id: 5 },
      { filename: "18-1.webp", id: 6 },
      { filename: "18-2.webp", id: 6 },
      { filename: "19.webp", id: 7 },
      { filename: "21.webp", id: 8 },
      { filename: "28.webp", id: 9 },
      { filename: "32.webp", id: 10 },
      // { filename: "37.webp", id: 13 },
      // { filename: "38.webp", id: 14 },
      // { filename: "40.webp", id: 15 },
      { filename: "41.webp", id: 11 },
      // { filename: "54.webp", id: 17 },
      // { filename: "57.webp", id: 18 },
      { filename: "58.webp", id: 12 },
      { filename: "59.webp", id: 13 },
      // { filename: "60.webp", id: 21 },
      { filename: "61.webp", id: 14 },
      { filename: "62.webp", id: 15 },
      { filename: "63.webp", id: 16 },
      { filename: "65.webp", id: 17 },
      { filename: "66.webp", id: 18 },
      { filename: "67.webp", id: 19 },
      { filename: "68.webp", id: 20 },
      { filename: "69.webp", id: 21 },
      { filename: "70.webp", id: 22 },
      { filename: "71.webp", id: 23 },
      { filename: "72.webp", id: 24 },
      { filename: "73.webp", id: 25 },
      { filename: "75.webp", id: 26 },
      { filename: "76.webp", id: 27 },
      { filename: "77.webp", id: 28 },
      { filename: "79.webp", id: 29 },
      { filename: "81.webp", id: 30 },
    ];

    // 配列をランダムにシャッフル
    this.productImgFiles.sort(() => Math.random() - 0.5);

    this.nearZ;
    this.farZ;
    this.currentZ = 0;
    this.items = [];
    this.scrollPercent = 0;
    this.scrollPercent2 = 0;
    this.heroHeight = 0;
    this.productsHeight = 0;
    this.isMovedToProducts = false;
    this.currentHoverItem = null; // 現在ホバー中のアイテムを保持

    this.productsLen = this.productImgFiles.length;
    this.zAxisInterval = this.sw >= this.pack.BP ? 300 : 600;
    this.allZAxisDistance = this.productsLen * this.zAxisInterval;
    this.autoScrollZ = 0;
    this.enabledAutoScroll = false;
    this.autoScrollSpeed = 15;
    this.currentAutoScrollSpeed = this.autoScrollSpeed;

    this.cameraTranslateX = 0;
    this.cameraTranslateY = 0;
    this.cameraEaseTranslateX = 0;
    this.cameraEaseTranslateY = 0;

    this.enabledButton = false;
    this.isPaused = false;
  }

  initEvents() {
    super.initEvents();

    if (!this.pack.hasTouch) {
      document.addEventListener("mousemove", (e) => {
        // 通常のマウス移動: カメラを平行移動（逆方向）
        const x = -(e.clientX / window.innerWidth - 0.5) * 200;
        const y = -(e.clientY / window.innerHeight - 0.5) * 200;

        this.cameraTranslateX = x;
        this.cameraTranslateY = y;
      });
    }
  }

  setDom() {
    super.setDom();

    this.heroDom = document.querySelector("main.top .hero");
    this.heroInnerDom = document.querySelector("main.top .hero .hero_inner");
    this.productsModal = document.querySelector("main.top .products_modal");
    this.progressBar = document.querySelector("main.top .hero .progress_bar");
    this.conceptVisual = document.querySelector(
      "main.top .hero .concept_visual",
    );
    this.conceptVideo = this.conceptVisual.querySelector("video");
    this.heroLogo = document.querySelector("main.top .hero .logo");

    this.heroMovableChunkContainer = document.querySelector(
      "main.top .hero .movable_chunk_container",
    );
    this.movableChunk = document.querySelector("main.top .hero .movable_chunk");

    this.productsDom = document.querySelector("main.top .section4");
    this.productsMovableChunkContainer = document.querySelector(
      "main.top .section4 .movable_chunk_container",
    );
  }

  start() {
    const tl = gsap.timeline({ delay: 0 });
    tl.to(this.heroLogo, {
      opacity: 0.0,
      duration: 0.03,
      repeat: 3,
      yoyo: true,
      ease: "steps(1)",
    })
      .to(this.heroLogo, {
        scale: 0.3,
        rotation: 60,
        duration: 0.5,
        delay: 0.15,
        ease: "quart.out",
      })
      .to(this.heroLogo, {
        scale: 1,
        rotation: 0,
        duration: 1.5,
        ease: "elastic.out(1, 0.2)",
        onComplete: () => {
          gsap.set(this.heroLogo, { clearProps: "transform" });
        },
      });

    gsap.delayedCall(0.9, () => {
      // 中央から飛び散るアニメーション
      this.items.forEach((item, i) => {
        gsap.to(item, {
          delay: i * 0.008,
          duration: 0.7 + Math.random() * 0.35,
          currentX: item.targetX,
          currentY: item.targetY,
          currentZ: item.targetZ,
          currentRotate: item.targetRotate,
          currentScale: item.targetScale,
          // currentOpacity: item.targetOpacity,
          ease: "expo.out",
          onUpdate: () => {
            item.element.style.transform = `translate3d(calc(-50% + ${item.currentX}vw), calc(-50% + ${item.currentY}vh), ${item.currentZ}px) rotate(${item.currentRotate}deg) scale(${item.currentScale})`;
            // item.imgWrap.style.opacity = item.currentOpacity;
          },
        });
      });

      this.enabledAutoScroll = true;
    });

    gsap.delayedCall(2.5, () => {
      this.threeDContainer.classList.add("enabled");
      this.enabledButton = true;
      this.pack.common.lockScroll = false;
      if (this.sw < this.pack.BP)
        document.documentElement.classList.remove("lock");
    });
  }

  createElements() {
    const imgPath = this.pack.ASSETS_PATH + "img/top/products/fv/";
    const fragment = document.createDocumentFragment();

    let targetFiles = this.productImgFiles;

    this.productsLen = targetFiles.length;
    this.allZAxisDistance = this.productsLen * this.zAxisInterval;
    const len = this.productsLen;

    targetFiles.forEach((file, i) => {
      let id = file.id;
      // 親となるdivを作成
      const wrap = document.createElement("div");
      wrap.classList.add("floating_item");

      // ホバー解除（リセット）処理を関数化して要素に持たせる
      wrap.resetHover = () => {
        if (wrap._clone) {
          this.frontStage.removeChild(wrap._clone);
          wrap._clone = null;
        }
        wrap.style.opacity = ""; // オリジナルを再表示
        this.overlay.classList.remove("show");
        if (this.currentHoverItem === wrap) this.currentHoverItem = null;
      };

      wrap.addEventListener("click", (event) => {
        if (!this.enabledButton) return;
        this.pack.productsModal.openModal(id - 1);
      });

      // ホバー時に複製を作って手前のステージに表示する（オリジナルは透明にして判定用に残す）
      // wrap.addEventListener('mouseenter', () => {
      wrap.addEventListener("mouseover", () => {
        if (!this.enabledButton) return;

        // 既に他のアイテムがホバー中なら強制リセット（排他制御）
        if (this.currentHoverItem && this.currentHoverItem !== wrap) {
          this.currentHoverItem.resetHover();
        }
        this.currentHoverItem = wrap;

        const clone = wrap.cloneNode(true);
        wrap._clone = clone; // 参照を保持
        this.frontStage.appendChild(clone);
        this.overlay.classList.add("show");

        requestAnimationFrame(() => {
          clone.classList.add("is-hover"); // ホバー状態のスタイルを強制適用
          wrap.style.opacity = 0; // オリジナルは見えなくする
        });

        this.pauseAutoScroll();
      });

      // wrap.addEventListener('mouseleave', () => {
      wrap.addEventListener("mouseout", () => {
        if (!this.enabledButton) return;
        wrap.resetHover();
        this.resumeAutoScroll();
      });

      let obj = this.pack.productList[id - 1];
      let keyColor = file.keyColor || obj.key_color;
      let textColor = file.textColor || obj.text_color;

      // 画像ラッパー
      const imgWrap = document.createElement("div");
      imgWrap.classList.add("img_wrap");
      wrap.appendChild(imgWrap);

      // ホバー画像
      const hoverImg = document.createElement("div");
      hoverImg.classList.add("hover_img");
      hoverImg.style.backgroundColor = keyColor;
      if (textColor === "black" && !file.keyColor) hoverImg.classList.add("black");
      imgWrap.appendChild(hoverImg);

      // メイン画像
      const img = document.createElement("img");
      img.src = imgPath + file.filename;
      img.classList.add("main_img");
      imgWrap.appendChild(img);

      // テキストラッパー（ホバー時に表示）
      const hoverContent = document.createElement("div");
      hoverContent.classList.add("hover_content");

      const copy = document.createElement("div");
      copy.classList.add("copy");
      copy.classList.add("condensed");
      copy.style.color = textColor === "black" ? textColor : keyColor;
      copy.innerHTML = obj.copy;
      hoverContent.appendChild(copy);

      const tit = document.createElement("div");
      tit.classList.add("tit");
      tit.classList.add("condensed");
      tit.style.color = textColor === "black" ? textColor : keyColor;
      tit.innerHTML = obj.tit;
      hoverContent.appendChild(tit);

      wrap.appendChild(hoverContent);

      // ランダム配置
      // 黄金角(約137.5度)を使って螺旋状に配置することで、重なりを防ぎつつ均等にばらけさせる
      const goldenAngle = 137.5 * (Math.PI / 180);
      const theta = i * goldenAngle;

      // 中心からの距離（半径）。画面中央を空けつつ、外側に広げる
      const minR = 20; // 中心から20%は空ける
      const maxR = 50; // 最大50%まで広げる
      const radius = minR + Math.random() * (maxR - minR);

      const x = Math.cos(theta) * radius;
      const y = Math.sin(theta) * radius;

      // 奥行き：手前から奥へ配置していく（マイナス方向が奥）
      // PCは1枚あたり300pxの間隔を空ける
      const z = 2200 + i * -this.zAxisInterval;
      const startZ = z - 20000;

      // ランダムな回転
      const rotate = (Math.random() - 0.5) * 30;

      // CSS Transformの設定
      // 初期状態は中央(0, 0)・回転なし
      wrap.style.transform = `translate3d(-50%, -50%, ${startZ}px) rotate(0deg) scale(0)`;

      // 手前の要素ほどz-indexを高くする（DOMの重なり順を視覚と合わせる）
      wrap.style.zIndex = len - i;

      // アイテム管理用配列に追加
      this.items.push({
        element: wrap,
        imgWrap: imgWrap,
        z: z,
        currentX: 0,
        currentY: 0,
        currentZ: startZ,
        currentRotate: 0,
        currentScale: 0,
        targetX: x,
        targetY: y,
        targetZ: z,
        targetScale: 1,
        targetRotate: rotate,
      });

      fragment.appendChild(wrap);
    });

    this.stage.appendChild(fragment);
  }

  pauseAutoScroll() {
    gsap.killTweensOf(this);
    gsap.to(this, {
      duration: 0.4,
      currentAutoScrollSpeed: 0,
      ease: "linear.out",
    });
  }

  resumeAutoScroll() {
    gsap.killTweensOf(this);
    gsap.to(this, {
      duration: 0.6,
      currentAutoScrollSpeed: this.autoScrollSpeed,
      ease: "linear.out",
    });
  }

  pause() {
    this.isPaused = true;
    this.pauseAutoScroll();
  }

  resume() {
    this.isPaused = false;
    this.resumeAutoScroll();
  }

  enterframeThinOut() {
    if (this.isPaused) return;

    // スクロール量に合わせてZ軸を進める(this.pack.scrollY は Common.js で更新されている)

    if (this.enabledAutoScroll) this.autoScrollZ += this.currentAutoScrollSpeed;

    // 追従のイージング
    let speed = this.sw >= this.pack.BP ? 5 : 9;

    this.scrollPercent = Math.min(
      1,
      this.pack.scrollY / (this.heroHeight - 1750),
    ); //1750はconceptVisual分の余白をとるため

    if (this.scrollPercent >= 1) {
      if (!this.conceptVisual.classList.contains("show")) {
        this.conceptVisual.classList.add("show");
        this.pack.header.changeGlobalNavColor(true);

        //videoを再生
        this.conceptVideo.play().catch(() => {});
      }
      let addY = this.heroInnerDom.getBoundingClientRect().top * -0.3;
      this.conceptVisual.style.transform = `translate3d(0, ${addY}px, 0)`;
    } else {
      if (this.conceptVisual.classList.contains("show")) {
        this.conceptVisual.classList.remove("show");
        this.pack.header.changeGlobalNavColor();
      }

      this.conceptVisual.style.transform = `translate3d(0, 0, 0)`;
    }

    if (this.scrollPercent >= 1) return;

    this.currentZ += (this.pack.scrollY * speed - this.currentZ) * 0.3;
    this.currentZ += this.autoScrollZ;

    let scrollPercent = this.scrollPercent;
    this.progressBar.style.clipPath = `inset(0 ${100 - scrollPercent * 100}% 0 0)`;

    // ステージ全体を手前に持ってくる（＝カメラが奥に進む）
    this.cameraEaseTranslateX +=
      (this.cameraTranslateX - this.cameraEaseTranslateX) / 10;
    this.cameraEaseTranslateY +=
      (this.cameraTranslateY - this.cameraEaseTranslateY) / 10;

    this.stage.style.transform = `translate3d(${this.cameraEaseTranslateX}px, ${this.cameraEaseTranslateY}px, ${this.currentZ}px)`;
    this.frontStage.style.transform = `translate3d(${this.cameraEaseTranslateX}px, ${this.cameraEaseTranslateY}px, ${this.currentZ}px)`;

    // 通り過ぎた要素を非表示にする処理
    const perspective = 5000; // CSSのperspectiveと同じ値
    if (this.items) {
      this.items.forEach((item, i) => {
        // 現在のZ座標 = 初期Z + 移動量
        let currentItemZ = item.z + this.currentZ;

        if (currentItemZ > 4000) {
          let z = (item.z = item.z - this.allZAxisDistance);
          item.element.style.transform = `translate3d(calc(-50% + ${item.currentX}vw), calc(-50% + ${item.currentY}vh), ${z}px) rotate(${item.currentRotate}deg)`;

          if (!item.isNoTransition) {
            item.element.classList.add("is_no_transition");
            item.isNoTransition = true;
          }
        } else if (currentItemZ < -this.allZAxisDistance - 1000) {
          let z = (item.z = item.z + this.allZAxisDistance);
          item.element.style.transform = `translate3d(calc(-50% + ${item.currentX}vw), calc(-50% + ${item.currentY}vh), ${z}px) rotate(${item.currentRotate}deg)`;
        }

        currentItemZ = item.z + this.currentZ;

        // 視点(perspectiveの値)より手前、あるいは視点付近に来たら非表示クラスをつける
        const shouldHide =
          currentItemZ > this.nearZ || currentItemZ < this.farZ;

        if (shouldHide) {
          if (!item.isHidden) {
            item.element.classList.add("is_hide");
            item.isHidden = true;
          }
        } else {
          if (item.isHidden) {
            item.element.classList.remove("is_hide");
            item.isHidden = false;
          }

          if (item.isNoTransition) {
            item.element.classList.remove("is_no_transition");
            item.isNoTransition = false;
          }
        }
      });
    }
  }

  getSectionsHeight() {
    this.heroHeight = this.heroDom.clientHeight;
    this.productsHeight = this.productsDom.clientHeight;
  }

  executeResize() {
    super.executeResize();
    this.sw = window.innerWidth;
    this.sh = window.innerHeight;
    this.getSectionsHeight();

    if (this.sw >= this.pack.BP) {
      this.nearZ = 2000;
      this.farZ = -8000;
    } else {
      this.nearZ = 0;
      this.farZ = -10000;
    }
  }
}
